export default __webpack_public_path__ + "static/media/membershippic.fe9355aa.png";